import type {
  Doctor,
  MonthAvailability,
  BookingRequest,
  BookingResponse,
  CedulaLookupResponse,
} from '@booking/shared';

const API = import.meta.env.VITE_API_URL;

if (!API) {
  console.warn('VITE_API_URL is not set. API calls will fail.');
}

class ApiError extends Error {
  status: number;
  code?: string;
  constructor(message: string, status: number, code?: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

async function http<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${API}${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...(init?.headers || {}) },
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { message?: string; code?: string };
    throw new ApiError(body.message || res.statusText, res.status, body.code);
  }
  return res.json() as Promise<T>;
}

export const api = {
  doctor: (id: string) => http<Doctor>(`/doctors/${encodeURIComponent(id)}`),

  availability: (
    doctorId: string,
    serviceId: string,
    year: number,
    month: number,
    /* minutos reales de la cita: con depilación por zonas cambia según lo escogido */
    minutos?: number,
  ) =>
    http<MonthAvailability>(
      `/availability?doctorId=${encodeURIComponent(doctorId)}` +
        `&serviceId=${encodeURIComponent(serviceId)}` +
        `&year=${year}&month=${month}` +
        (minutos ? `&minutos=${minutos}` : ''),
    ),

  book: (body: BookingRequest) =>
    http<BookingResponse>('/book', { method: 'POST', body: JSON.stringify(body) }),

  lookupCedula: (cedula: string) =>
    http<CedulaLookupResponse>(`/lookup-cedula?cedula=${encodeURIComponent(cedula)}`),
};

export { ApiError };
